<template>
  <div style="padding:20px;margin:20px;background:#fff">
    <a-table
      size="small"
      :dataSource="dataSource"
      :columns="columns"
      :pagination="false"
    >
      <template #flowRate>
        <span>
          剩余可用流量
          <a-tooltip>
            <template #title
              >剩余流量按照1-（运行中和运行中（暂停）状态的试验流量占用）进行统计</template
            >
            <QuestionCircleOutlined />
          </a-tooltip>
        </span>
      </template>
      <template #unallocated="{record}">
        <div>{{ record.unallocated }} %</div>
      </template>
      <template #create="{ record }">
        {{ record.creater ? record.creater : '--' }} / {{ record.createTime }}
      </template>
      <template #name="{ record }">
        <a-tooltip placement="topLeft">
          <template #title>
            <span>{{ record.name }}</span>
          </template>
          <span>{{ record.name }}</span>
        </a-tooltip>
      </template>
      <template #description="{ record }">
        <a-tooltip placement="topLeft">
          <template #title>
            <span>{{ record.description }}</span>
          </template>
          <span>{{ record.description }}</span>
        </a-tooltip>
      </template>
      <template #action="{ record }">
        <a-button size="small" type="link" @click="editLayer(record)"
          >编辑</a-button
        >
        <a-button size="small" type="link" @click="allocationFlow(record)"
          >分配流量</a-button
        >
        <a-popconfirm
          :disabled="record.experimentCount > 0"
          title="请确定是否删除？"
          ok-text="确认"
          cancel-text="取消"
          @confirm="deleteLayer(record)"
        >
          <a-button
            size="small"
            type="link"
            :disabled="record.experimentCount > 0"
            >删除</a-button
          >
        </a-popconfirm>
      </template>
    </a-table>
    <div style="margin-top: 10px;display: flex; justify-content: space-between">
      <div>
        共 {{ pageInfo.total }} 条记录 第 {{ pageInfo.pageNum }} /
        {{ pageInfo.pages }} 页
      </div>
      <a-pagination
        v-model:current="pageInfo.pageNum"
        :pageSize="pageInfo.pageSize"
        :page-size-options="pageSizeOptions"
        show-quick-jumper
        show-size-changer
        :total="pageInfo.total"
        @change="onPageChange"
      >
        <template #buildOptionText="props">
          <span>{{ props.value }}条/页</span>
        </template>
      </a-pagination>
    </div>
  </div>
</template>

<script>
import { inject, toRefs, reactive } from 'vue'
import { QuestionCircleOutlined } from '@ant-design/icons-vue'
export default {
  components: { QuestionCircleOutlined },
  setup() {
    const initData = inject('initState')
    const state = reactive({
      pageSizeOptions: ['20', '50', '100'],
      columns: [
        {
          title: '实验层名称',
          dataIndex: 'name',
          key: 'name',
          ellipsis: true,
          slots: { customRender: 'name' }
        },
        {
          dataIndex: 'unallocated',
          key: 'unallocated',
          slots: { customRender: 'unallocated', title: 'flowRate' },
          width: 160
        },
        {
          title: '运行实验数',
          dataIndex: 'experimentCount',
          key: 'experimentCount',
          width: 100
        },
        {
          title: '描述',
          dataIndex: 'description',
          key: 'description',
          ellipsis: true,
          slots: { customRender: 'description' }
        },
        {
          title: '创建人/创建日期',
          dataIndex: 'create',
          key: 'create',
          slots: { customRender: 'create' },
          width: 300
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
          width: 200
        }
      ]
    })
    return {
      ...toRefs(initData),
      ...toRefs(state)
    }
  }
}
</script>
<style></style>
